import { BiUser, BiCog, BiLogOut } from "react-icons/bi";
import { useNavigate } from "react-router";

import { Heading, Stack, Text, Box, Grid } from "@chakra-ui/react";

import { CenteredLayout } from "@/components/2/CenteredLayout";
import { AppConfig } from "@/components/app-config";

export const Hub = () => {
  const navigate = useNavigate();

  return (
    <CenteredLayout maxW="4xl">
      <Stack gap="6">
        <Text color="fg.muted" textAlign="center">
          Bienvenue sur DSIT. Choisis une section pour commencer.
        </Text>
      </Stack>

      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
        {/* Self Section - Always visible */}
        <Box
          as="button"
          onClick={() => navigate("/2/self")}
          borderRadius="lg"
          borderWidth={2}
          borderColor="gray.300"
          p={8}
          textAlign="left"
          transition="all 0.2s"
          _hover={{
            borderColor: "blue.500",
            transform: "translateY(-2px)",
            boxShadow: "lg",
          }}
          _active={{
            transform: "translateY(0)",
          }}
        >
          <Stack gap={4}>
            <Box fontSize="4xl" color="blue.500" as={BiUser} />
            <Heading size="md">Mes informations</Heading>
            <Text color="fg.muted" fontSize="sm">
              Consulte tes informations personnelles et ton profil dans le système DSIT.
            </Text>
          </Stack>
        </Box>

        <Box
          as="button"
          onClick={() => navigate("/2/admin")}
          borderRadius="lg"
          borderWidth={2}
          borderColor="gray.300"
          p={8}
          textAlign="left"
          transition="all 0.2s"
          _hover={{
            borderColor: "purple.500",
            transform: "translateY(-2px)",
            boxShadow: "lg",
          }}
          _active={{
            transform: "translateY(0)",
          }}
        >
          <Stack gap={4}>
            <Box fontSize="4xl" color="purple.500" as={BiCog} />
            <Heading size="md">Interface admin</Heading>
            <Text color="fg.muted" fontSize="sm">
              Gère les collaborateurs, les géographies, et les paramètres de DSIT.
            </Text>
          </Stack>
        </Box>
      </Grid>

      <Stack direction="row" align="center" justify="center" gap={6} mt={8}>
        <Box
          as="button"
          onClick={() => navigate("/2/mfa-aircall")}
          color="fg.muted"
          fontSize="sm"
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
        >
          <Text>Codes MFA Aircall Astreinte</Text>
        </Box>
        <Box
          as="button"
          onClick={AppConfig.logout}
          display="flex"
          alignItems="center"
          gap={2}
          color="fg.muted"
          fontSize="sm"
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
        >
          <BiLogOut />
          <Text>Se déconnecter</Text>
        </Box>
      </Stack>
    </CenteredLayout>
  );
};
